import React from 'react'
import { useSelector } from 'react-redux'
import { mixUrl } from 'multiPublic'

import IconBtn from '../../../VideoList/Image/video-btn-1.png'
import './index.scss'

const getCover = (coverPic) => {
    if (!coverPic) return ''

    try {
        const cover = typeof coverPic === 'string' ? JSON.parse(coverPic) : coverPic
        return cover.pc || cover.video_pc || cover.m || cover.mainImg || ''
    } catch (err) {
        return ''
    }
}

const getVideoLink = (video) => {
    if (!video.id || !video.publishTime) return ''
    return mixUrl.main(`/video/detail/${video.id}/${video.publishTime}`)
}

export default () => {
    const videoHotList = useSelector((state) => state.video.videoHotList || [])
    const videos = videoHotList.slice(0, 4)

    if (videos.length === 0) return null

    return (
        <section className="home-hot-video-list">
            <h2 className="home-hot-video-heading">热门视频</h2>
            <div className="home-hot-video-grid">
                {videos.map((video) => {
                    const videoLink = getVideoLink(video)

                    return (
                        <article
                            className="home-hot-video-item"
                            key={video.id || `${video.title}-${video.publishTime}`}
                        >
                            <a className="home-hot-video-cover" href={videoLink}>
                                <img src={getCover(video.coverPic)} alt={video.title} />
                                <span className="home-hot-video-play">
                                    <img src={IconBtn} alt="播放" />
                                </span>
                            </a>
                            <a className="home-hot-video-title" href={videoLink}>{video.title}</a>
                        </article>
                    )
                })}
            </div>
        </section>
    )
}
